import { render, staticRenderFns } from "./customDashboardCalendar.vue?vue&type=template&id=34ba59a6&scoped=true"
import script from "./customDashboardCalendar.vue?vue&type=script&lang=js"
export * from "./customDashboardCalendar.vue?vue&type=script&lang=js"
import style0 from "./customDashboardCalendar.vue?vue&type=style&index=0&id=34ba59a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ba59a6",
  null
  
)

export default component.exports